import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _class2, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { observable } from 'mobx';
import { Model } from 'libx';
import { collection } from '../utils/collection';
export var Participant = (_class = /*#__PURE__*/function (_Model) {
  function Participant(conversation, primeMember) {
    var _this;
    _classCallCheck(this, Participant);
    _this = _callSuper(this, Participant);
    // Simulating Member.none. Convo participants are localized
    // This would need other default values if other attrs
    // are used in parse()
    _initializerDefineProperty(_this, "member", _descriptor, _this);
    _this.conversation = conversation;
    _this.primeMember = primeMember;
    return _this;
  }
  _inherits(Participant, _Model);
  return _createClass(Participant, [{
    key: "parse",
    value: function parse(attrs) {
      var _this$primeMember;
      var member = (_this$primeMember = this.primeMember({
        workspace_id: this.conversation.workspaceId,
        user_id: attrs.user_id,
        user_public_id: attrs.user_public_id
      })) !== null && _this$primeMember !== void 0 ? _this$primeMember : this.member;
      return {
        member: member
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "member", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {
      userId: 'ConversationParticipant.userId.none'
    };
  }
}), _class);
var Conversation = (_class2 = /*#__PURE__*/function (_Model2) {
  function Conversation(primeMember) {
    var _this2;
    _classCallCheck(this, Conversation);
    _this2 = _callSuper(this, Conversation);
    _initializerDefineProperty(_this2, "hasMoreMessages", _descriptor2, _this2);
    _initializerDefineProperty(_this2, "loadingMore", _descriptor3, _this2);
    _initializerDefineProperty(_this2, "accessDenied", _descriptor4, _this2);
    _initializerDefineProperty(_this2, "cursor", _descriptor5, _this2);
    _initializerDefineProperty(_this2, "notFirst", _descriptor6, _this2);
    _initializerDefineProperty(_this2, "id", _descriptor7, _this2);
    _initializerDefineProperty(_this2, "name", _descriptor8, _this2);
    _initializerDefineProperty(_this2, "workspaceId", _descriptor9, _this2);
    _initializerDefineProperty(_this2, "createdByUserId", _descriptor10, _this2);
    _initializerDefineProperty(_this2, "active", _descriptor11, _this2);
    _initializerDefineProperty(_this2, "muted", _descriptor12, _this2);
    _initializerDefineProperty(_this2, "meta", _descriptor13, _this2);
    _this2.participants = collection({
      getModelId: function getModelId(m) {
        return m.member.userId;
      },
      getDataId: function getDataId(d) {
        return d.user_id;
      },
      create: function create() {
        return new Participant(_this2, _this2.primeMember);
      }
    });
    _this2.primeMember = primeMember;
    return _this2;
  }
  _inherits(Conversation, _Model2);
  return _createClass(Conversation, [{
    key: "parse",
    value: function parse(json, opts) {
      var _json$workspace_id;
      this.workspaceId = (_json$workspace_id = json.workspace_id) !== null && _json$workspace_id !== void 0 ? _json$workspace_id : this.workspaceId;
      this.participants.reset(json.participants);
      return {
        id: json.id,
        name: json.name,
        createdByUserId: json.created_by_user_id,
        active: json.active,
        cursor: json.cursor || null,
        hasMoreMessages: json.hasMoreMessages || false,
        loadingMore: json.loadingMore || false,
        notFirst: json.notFirst || false,
        muted: json.muted || false,
        meta: parseMeta(json)
      };
    }
  }]);
}(Model), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "hasMoreMessages", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "loadingMore", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "accessDenied", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "cursor", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "notFirst", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "name", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "createdByUserId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "active", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "muted", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "meta", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {
      type: 'Unknown'
    };
  }
}), _class2);
export { Conversation as default };
/**
 * Parses conversation meta.
 */
function parseMeta(_ref) {
  var id = _ref.id,
    meta = _ref.meta;
  if (!meta) {
    return undefined;
  }
  switch (meta.type) {
    case 'Job':
      {
        if (!meta.id) {
          console.error("Attempted parsing Job conversation meta, but no ID was present. Convo ID: ".concat(id));
          return {
            type: 'Unknown'
          };
        }
        return {
          type: 'Job',
          name: meta.name || '<Unknown Job>',
          id: meta.id
        };
      }
    default:
      {
        return {
          type: 'Unknown'
        };
      }
  }
}
//# sourceMappingURL=Conversation.js.map
